import React from 'react'
import styled, { css } from 'styled-components'
import { utagLink } from '../../tealium'
import useAmplitude from '~/hooks/useAmplitude'
import { IconEmail } from '../_svgs/Mail/Mail'
import { IconGift } from '../_svgs/GiftPackage/GiftPackage'
import { IconSmsText } from '../_svgs/SmsText/SmsText'

export const FooterSubscribes = () => {
  const { trackHeaderFooterClicked } = useAmplitude()
  const isIntl = window ? window?.isIntl : false

  const emailHandler = () => {
    if (window) {
      window._klOnsite = window._klOnsite || []
      window._klOnsite.push(['openForm', 'WXaT6m'])
    }
    utagLink({
      'tealium_event': 'email-sms-popup-trigger',
    })
    trackHeaderFooterClicked({
      L1: 'ContactEmailRefer',
      HeaderFooterType: 'footer',
    })
  }

  const smsHandler = () => {
    if (window) {
      window._klOnsite = window._klOnsite || []
      window._klOnsite.push(['openForm', 'Yx8KEP'])
    }
    utagLink({
      'tealium_event': 'email-sms-popup-trigger',
    })
    trackHeaderFooterClicked({
      L1: 'ContactSMSRefer',
      HeaderFooterType: 'footer',
    })
  }

  const trackFooterClick = (link) => {
    trackHeaderFooterClicked({
      L1: 'ContactEmailSMSRefer',
      HeaderFooterType: 'footer',
      HeaderFooterLink: link,
    })
  }

  const handleIconClick = (e) => {
    trackFooterClick(e.currentTarget.href)
  }

  return (
    <FooterSubscribeRow>
      <FooterSubscribeContainer>
        {!isIntl && (
          <SubscribeBlock
            styles={css`
              @media (max-width: 767px) {
                padding-bottom: 14px;
                margin-bottom: 14px;
                border-bottom: 1px solid ${(props) => props.theme.paleSage};
              }
            `}
          >
            <SubscribeIcon>
              <IconGift
                styles={css`
                  flex-shrink: 0;
                `}
              />
            </SubscribeIcon>

            <SubscribeA
              data-target='refer-a-friend'
              className='cTest_footer_raf'
              href='https://www.swansonvitamins.com/landing-pages/refer-a-friend.html'
              onClick={handleIconClick}
            >
              <SubscribeTitle>
                Give friends 20% off their first order
              </SubscribeTitle>
              <SubscribeLabel>
                Get 20% off when they make a purchase!
              </SubscribeLabel>
            </SubscribeA>
          </SubscribeBlock>
        )}
        {!isIntl && (
          <SubscribeBlock
            styles={css`
              @media (max-width: 767px) {
                padding-bottom: 14px;
                margin-bottom: 14px;
                border-bottom: 1px solid ${(props) => props.theme.paleSage};
              }
            `}
          >
            <SubscribeIcon>
              <IconEmail
                styles={css`
                  flex-shrink: 0;
                `}
              />
            </SubscribeIcon>
            <SubscribeButton
              className='footer-btn-trck cTest_footer_get-deals klaviyo_form_trigger'
              data-target='email-trigger'
              onClick={emailHandler}
            >
              <SubscribeTitle>Join for our exclusive emails</SubscribeTitle>
              <SubscribeLabel>
                Get deals and news straight to your inbox!
              </SubscribeLabel>
            </SubscribeButton>
          </SubscribeBlock>
        )}
        <SubscribeBlock>
          <SubscribeIcon>
            <IconSmsText
              styles={css`
                flex-shrink: 0;
              `}
            />
          </SubscribeIcon>
          <SubscribeButton
            className='footer-btn-trck cTest_footer_sms klaviyo_form_trigger'
            data-target='sms-trigger'
            onClick={smsHandler}
          >
            <SubscribeTitle>Get our exclusive SMS text offers</SubscribeTitle>
            <SubscribeLabel>
              Receive SMS alerts on our best sales and deals!
            </SubscribeLabel>
          </SubscribeButton>
        </SubscribeBlock>
      </FooterSubscribeContainer>
    </FooterSubscribeRow>
  )
}

const FooterSubscribeRow = styled.div`
  background-color: ${(props) => props.theme.cream};
  display: flex;
  align-items: center;
`

const FooterSubscribeContainer = styled.div`
  background-color: ${(props) => props.theme.cream};
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  max-width: 1420px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  padding-bottom: 28px;
  padding-top: 28px;
  gap: 20px;
  @media (max-width: 1420px) {
    padding-left: 15px;
    padding-right: 15px;
    gap: 15px;
  }
  @media (max-width: 767px) {
    flex-direction: column;
    gap: 0;
  }
`

const SubscribeBlock = styled.div`
  display: flex;
  gap: 16px;
  @media (min-width: 1420px) {
    width: calc(100% / 3);
  }
  @media (max-width: 767px) {
    gap: 10px;
    width: 100%;
  }
  @media (min-width: 426px) and (max-width: 767px) {
    justify-content: center;
  }
  ${(props) => props.styles};
`

const SubscribeTitle = styled.h4`
  text-align: left;
  color: inherit;
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
  @media (max-width: 767px) {
    font-size: 16px;
    line-height: 22px;
  }
`

const SubscribeLabel = styled.h5`
  text-align: left;
  color: inherit;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  @media (max-width: 767px) {
    font-size: 14px;
    line-height: 20px;
  }
`

const SubscribeContent = styled.div`
  display: flex;
  flex-direction: column;
`

const SubscribeButton = styled.button`
  color: ${(props) => props.theme.textBlack};
  cursor: pointer;
  background-color: transparent;
  border: none;
  display: flex;
  flex-direction: column;
  height: auto;
  transition: color 0.15s ease;
  &:hover {
    color: ${(props) => props.theme.darkOrange};
  }
`

const SubscribeA = styled.a`
  color: ${(props) => props.theme.textBlack} !important;
  display: flex;
  flex-direction: column;
  transition: color 0.15s ease;
  text-decoration: none;
  &:hover {
    color: ${(props) => props.theme.darkOrange} !important;
  }
`

const SubscribeIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  flex-shrink: 0;
`
